import React, { useEffect, useState } from 'react'
import '../styles/MemberDetails.css'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SideBar from '../components/SideBar';
import '../styles/WalletPage.css';
import cash from'../assets/images/tc-cash-wallet 1.png';
import units from'../assets/images/tc-units-wallet 2.png';
import wallet2 from '../assets/images/Wallet03.1 1.png';
import wallet1 from '../assets/images/Wallet01 5.png';
import dollarY from '../assets/images/Dollar Bag (1).png';
import dollarG from '../assets/images/Dollar Bag.png';
import history1 from '../assets/images/Group 37483.png';
import oldbank from '../assets/images/bank-pound-icon2 4.png';
import WalletDetails from '../components/WalletDetails';
import CustomerWalletSummaryCard from '../components/CustomerWalletSummaryCard';
import { customerService } from '../services/customerServices';

function CustomerWalletPage() {
    const location = useLocation();
    const customer = location.state?.customer;
    const navigate = useNavigate();

    const goToWallet = () => {
      navigate('/customer-wallet-details', {state: {customer}})
    }

    const goToWalletSummary = () => {
      navigate('/customer-wallet-summary', {state: {customer}})
    }

    const goToRequestHistory = () => {
        navigate('/customer-cash-request-history', {state: {customer}})
    }

    const goToCustomerDetails = () => {
        navigate('/customer-details', {state: {customer}})
    }

    console.log("Received customer:", customer);

    const [walletData, setWalletData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      const fetchWallet = async () => {
        try {
          const id = customer?.id || customer?.Customer_id || customer?.customer_id;
          if (id) {
            const data = await customerService.getCustomerWallet(id);
            setWalletData(data);
          }
        } catch (error) {
          console.error("Error fetching wallet details:", error);
        } finally {
          setLoading(false);
        }
      };
      fetchWallet();
    }, [customer]);

    // Safely access wallet data with fallbacks
    const totalPoints = walletData?.wallet?.units || customer?.wallet_details?.primary_wallet?.points || customer?.wallet_details?.total_points || 0;
    const cashBalance = walletData?.earned_bonus_reward_wallet?.cash || customer?.wallet_details?.earned_bonus_reward_wallet?.cash || 0;
    const earnedTopCoinPoints = walletData?.earned_top_coinown?.units || customer?.wallet_details?.earned_top_coinown?.points || 0;
    
    // Get recent transactions if available
    const recentTransactions = walletData?.transactions || customer?.wallet_details?.recent_transactions || [];

  return (
    <div className="member-details-layout">
      <SideBar />

        <div className="member-details-main">

            {/* Header */}
            <div className="details-header">
                <h2>Customer Details</h2>
                <p>You can edit your details to update your profile</p>
            </div>

            {/* Breadcrumb */}
            <div className="breadcrumb">
                <Link to="/dashboard" className="breadcrumb-link">Home</Link>
                <span className="breadcrumb-separator">{">"}</span>
                <Link to="/manage-customer" className="breadcrumb-link">Manage Customer</Link>
                <span className="breadcrumb-separator">{">"}</span>
                <span className="breadcrumb-current">Customer Details</span>
            </div>

            {/* buttons */}
            <div className="top-bar">
            {/* tap buttons */}
                <div className="top-buttons">
                    <button className="tab-btn" onClick={goToCustomerDetails}>Personal Details</button>
                    <button className="tab-btn active" onClick={goToWallet}>Wallet Details</button>
                    {/* <button className="tab-btn" onClick={goToWalletSummary}>Card Promotion Wallet Summary</button> */}
                    <button className="tab-btn" onClick={goToRequestHistory}>Cash Request History</button>
                </div>
            </div>

            {/* Customer Wallet Summary Table matching exact mockup */}
            {/* <div style={{ marginTop: "20px" }}>
                <CustomerWalletSummaryCard
                    initialCustomer={customer}
                    initialCustomerId={customer?.id || customer?.Customer_id || customer?.customer_id}
                />
            </div> */}

            {/* Wallet Section */}
            <div className="wallet-section">
                <WalletDetails
                    imgH={wallet2}
                    imgT={dollarG}
                    imgHi={history1}
                    title="Sign-Up reward TopCoin"
                    amount={`${totalPoints.toLocaleString()} units`}
                    subText="Available TopCoin"
                    bgColor="#f0fdf4"
                    bgColor1="#dcfce7"
                    historyLink="/customer-units-transaction-history"
                    stateData={{ customer }}
                />

                <WalletDetails
                    imgH={wallet2}
                    imgT={dollarG}
                    imgHi={history1}
                    title="Earned TopCoin Wallet"
                    amount={`${earnedTopCoinPoints.toLocaleString()} units`}
                    subText="Available TopCoin"
                    bgColor="#f0fdf4"
                    bgColor1="#dcfce7"
                    showButton={false}
                />

                <WalletDetails
                    imgH={wallet1}
                    imgT={dollarY}
                    imgHi={history1}
                    title="Earned Bonus Reward Wallet (Customer)"
                    amount={loading ? "Loading..." : `£ ${cashBalance}`}
                    subText="Available Cash"
                    bgColor="#fff7ed"
                    bgColor1="#ffedd5"
                    showButton={false}
                />

                <WalletDetails
                    imgH={oldbank}
                    imgT={dollarY}
                    title="Withdraw"
                    amount={`£ ${(0).toFixed(2)}`}
                    subText="Available Cash"
                    bgColor="#f5f5f5"
                    bgColor1="#e0e0e0"
                    buttonText="Withdraw"
                    disabled={true}
                    showButton={true}
                />
            </div>

{/* Retail Sales History Link */}
            <div className="wallet-section">
                <Link
                    to="/customer-sales-history"
                    state={{ customer }}
                    className="wallet-link"
                    style={{ fontSize: '14px' }}
                >
                    View Retail Sales History &gt;&gt;
                </Link>
            </div>
            
            {/* Recent Transactions Section */}
            {/* {recentTransactions.length > 0 && (
                <div className="recent-transactions-section">
                    <h3>Recent Transactions</h3>
                    <div className="transactions-table">
                        <table>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Type</th>
                                    <th>Amount</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {recentTransactions.map((transaction, index) => (
                                    <tr key={transaction.id || index}>
                                        <td>{transaction.date}</td>
                                        <td>
                                            <span className={`transaction-type ${transaction.transaction_type}`}>
                                                {transaction.transaction_type}
                                            </span>
                                        </td>
                                        <td className={`amount ${transaction.transaction_type}`}>
                                            {transaction.transaction_type === 'credit' ? '+' : '-'}{transaction.amount}
                                        </td>
                                        <td>{transaction.description}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {recentTransactions.length >= 10 && (
                        <Link to="/customer-units-transaction-history" className="view-all-link">
                            View All Transactions &gt;&gt;
                        </Link>
                    )}
                </div>
            )} */}
        </div>       
    </div>
  )
}

export default CustomerWalletPage